module.exports = __webpack_public_path__ + "static/security2-2df86ad4c6dfdbe7e5a7509e9c101abc.png";